module.exports = __webpack_public_path__ + "img/gq11.199beaa9.png";